import * as React from 'react';

export const Title = ({ title, subtitle }) => (
    <div>
        <h3 className='title'>{title}</h3>
        <h5 className='subtitle'>{subtitle}</h5>
    </div>
);
